import { useTooltipGuide } from '@/hooks/useTooltipGuide';
import { MicroTooltip } from './MicroTooltip';

export const TooltipGuideManager = () => {
  const {
    currentTooltip,
    currentIndex,
    totalSteps,
    isActive,
    anchorElement,
    next,
    dismiss,
  } = useTooltipGuide();

  // Don't render if not active or no tooltip
  if (!isActive || !currentTooltip) return null;

  // Don't render if anchor not found
  if (!anchorElement) return null;

  return (
    <MicroTooltip
      tooltip={currentTooltip}
      anchorElement={anchorElement}
      currentIndex={currentIndex}
      totalSteps={totalSteps}
      onNext={next}
      onDismiss={dismiss}
    />
  );
};
